import React from 'react'
import { useTranslation } from 'react-i18next'

import Badge from '@/modules/components/Badge'
import Box from '@/modules/components/Box'
import Column from '@/modules/components/Column'
import Flex from '@/modules/components/Flex'
import Link from '@/modules/components/Link'
import Row from '@/modules/components/Row'
import Typography from '@/modules/components/Typography'

import type { NavLink, NavLinkBlock, NavLinkColumn } from './data/types'

export const DesktopMenu = ({
  menuData,
  menuWidth,
}: {
  menuData: NavLinkColumn[]
  menuWidth: string
}) => {
  const { t } = useTranslation('navigation')

  const renderMenuItem = ({ tTitle, href, tBadgeTitle }: NavLink) => (
    <Link href={href}>
      <Flex alignItems="center">
        <Typography variant="textCta2" color="secondaryLightGrey" leadingTrim>
          {t(tTitle)}
        </Typography>
        {tBadgeTitle && <Badge ml={1}>{t(tBadgeTitle)}</Badge>}
      </Flex>
    </Link>
  )

  const renderColumn = ({ tTitle, items }: NavLinkBlock) => (
    <>
      <Typography variant="subtitle2" color="primaryPaleWhite" mb={2}>
        {t(tTitle)}
      </Typography>
      {items.map((item, i) => (
        <Box key={item.tTitle} mb={i !== items.length - 1 ? 1 : 0}>
          {renderMenuItem(item)}
        </Box>
      ))}
    </>
  )

  return (
    <Row>
      {menuData.map((columnItems, i) => {
        const adjustWidth =
          columnItems.length === 2 &&
          columnItems[0].tTitle === 'products.exchange'
            ? '20%'
            : menuWidth
        return (
          <Column width={adjustWidth} key={i}>
            {columnItems.map((column, i) => (
              <Box key={i} mb={i !== columnItems.length - 1 ? 4 : 0}>
                {renderColumn(column)}
              </Box>
            ))}
          </Column>
        )
      })}
    </Row>
  )
}
